var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66683 10.6666C3.56226 10.6666 2.66683 11.5621 2.66683 12.6666C2.66683 13.0348 2.96531 13.3333 3.3335 13.3333H8.00016C8.33354 13.3333 8.66683 13.6666 8.66683 14C8.66683 14.3682 8.36835 14.6666 8.00016 14.6666H3.3335C2.22893 14.6666 1.3335 13.7712 1.3335 12.6666C1.3335 10.8257 2.82588 9.3333 4.66683 9.3333H8.00016L8.66683 9.33328C9.03504 9.33326 9.3335 9.63174 9.3335 9.99994C9.3335 10.3681 9.03501 10.6666 8.6668 10.6666H8.00016H4.66683Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.6667C13.3333 10.2985 13.0349 10 12.6667 10C12.2985 10 12 10.2985 12 10.6667V12H10.6667C10.2985 12 10 12.2985 10 12.6667C10 13.0349 10.2985 13.3333 10.6667 13.3333H12V14.6667C12 15.0349 12.2985 15.3333 12.6667 15.3333C13.0349 15.3333 13.3333 15.0349 13.3333 14.6667V13.3333H14.6667C15.0349 13.3333 15.3333 13.0349 15.3333 12.6667C15.3333 12.2985 15.0349 12 14.6667 12H13.3333V10.6667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66683 2.66659C5.56226 2.66659 4.66683 3.56202 4.66683 4.66658C4.66683 5.77115 5.56226 6.66658 6.66683 6.66658C7.7714 6.66658 8.66683 5.77115 8.66683 4.66658C8.66683 3.56202 7.7714 2.66659 6.66683 2.66659ZM3.3335 4.66658C3.3335 2.82564 4.82588 1.33325 6.66683 1.33325C8.50778 1.33325 10.0002 2.82564 10.0002 4.66658C10.0002 6.50753 8.50778 7.99992 6.66683 7.99992C4.82588 7.99992 3.3335 6.50753 3.3335 4.66658Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUsers);
export default __webpack_public_path__ + "static/media/add-users.6e2fe4f2.svg";
export { ForwardRef as ReactComponent };